export class ConfigBuilder {
  private config: any = {};

  withRequestAborting(controller: any) {
    if (controller) {
      this.config = { ...this.config, signal: controller.signal };
    }
    return this;
  }

  withEsriAuthorizationHeader(arcgisToken: string | undefined) {
    if (arcgisToken != null) {
      this.config = {
        ...this.config,
        headers: {
          ...this.config.headers,
          'X-Esri-Authorization': arcgisToken
        }
      };
    }
    return this;
  }

  build() {
    return { ...this.config };
  }
}
